var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[(_vm.chart && _vm.tasks.length)?_c(_vm.chartComponent,{tag:"component",attrs:{"tasks":_vm.tasks}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }